const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tp-tbkorder/search', { params })
  },
  searchItemInfo ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tp-tbkorder/search-item-info', { params })
  },
  idOrUrlGetItem ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tp-tbkorder/id-or-url-get-item', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
